import { isBrandPointer } from './brand';
import { isPlainObject } from './isPlainObject';
import type { DbProtocolManifest } from './types';

export const protocolManifestPath = (protocolId: string): string =>
  `protocols/${protocolId}/manifest.json`;

/** Object metadata of the manifest copy, in the web SDK's shape; the Admin SDK takes it as `metadata`. */
export const PROTOCOL_MANIFEST_METADATA = {
  contentType: 'application/json',
  cacheControl: 'no-cache',
} as const;

export const publicProtocolManifest = ({
  definition,
  translations,
  style,
  images,
  brand,
}: DbProtocolManifest): DbProtocolManifest => ({
  definition,
  translations,
  ...(style !== undefined && { style }),
  ...(images !== undefined && { images }),
  ...(brand !== undefined && { brand }),
});

const isString = (value: unknown): value is string => typeof value === 'string';

const isStringRecord = (value: unknown): value is Record<string, string> =>
  isPlainObject(value) && Object.values(value).every(isString);

const isAbsentOr =
  (check: (value: unknown) => boolean) =>
  (value: unknown): boolean =>
    value === undefined || check(value);

export const isProtocolManifest = (
  value: unknown
): value is DbProtocolManifest =>
  isPlainObject(value) &&
  isString(value['definition']) &&
  isStringRecord(value['translations']) &&
  isAbsentOr(isString)(value['style']) &&
  isAbsentOr(isStringRecord)(value['images']) &&
  isAbsentOr(isBrandPointer)(value['brand']);
